import { render, staticRenderFns } from "./SearchSorts.vue?vue&type=template&id=69d2acd0"
import script from "./SearchSorts.vue?vue&type=script&lang=js"
export * from "./SearchSorts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports